module.exports = __webpack_public_path__ + "assets/img/b19ddd993c3b5ae66833a48ae0182774.png";